// imports react
import React, { useEffect, useState } from 'react';

//imports components
import styles from '../styles/switchmode.module.css';
import { Moon, Sun } from 'lucide-react';

export function SwitchMode({ onModeChange }) {
  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  useEffect(() => {
    window.localStorage.setItem('darkMode', darkMode);
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    onModeChange(darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  return (
    <div className={styles.theme_switch_wrapper}>
      <label className={styles.theme_switch} htmlFor="checkbox">
        <input
          type="checkbox"
          id="checkbox"
          onChange={toggleDarkMode}
          checked={darkMode}
        />
        {darkMode ? (null) : (<div className={styles.sun}><Sun /></div>)}
        <div className={`${styles.slider} ${styles.round}`}></div>
        {darkMode ? (<div className={styles.moon}><Moon /></div>) : (null)}
      </label>
    </div>
  );
}
